export enum PLATFORM_VERSION {
  V1 = "V1",
  V2 = "V2",
}

export enum STEPS {
  STEP1 = "STEP1",
  STEP2 = "STEP2",
  STEP3 = "STEP3",
  REVIEW = "REVIEW",
  COMPLETED = "COMPLETED",
}

export enum AWARD_RECOMMENDED {
  GOOD = "Good",
  SATISFACTORY = "Satisfactory",
  NOT_RECOMMENDED = "NotRecommended",
}

export enum AWARD_STATUS {
  AWARDED = "awarded",
  AWARDED_EDITION = "awarded_edition",
  NOT_AWARDED = "not_awarded",
  WAS_AWARDED = "was_awarded",
  UNKNONWN = "unknown",
}

export const FILENAMES = {
  RESULTS: "_results.json",
  TEMPLATE: "_template.json",
  EXPERT_FEEDBACK: "_expert_feedback.json",
  WORKFLOW: "_workflow.json",
  WORKFLOW_TEMPLATE: "_workflow_template.json",
  FEEDBACK_TEMPLATE: "_feedback_template.json",
}

export enum INVITE_TYPE {
  PROVIDER = "provider",
  EXPERT = "expert",
  NONE = "none",
}

export const SUBMIT_GRACE_TIME_MINUTES = 60;

export enum COMMENT_STATUS {
  REOPENED = "REOPENED",
  ACTION_REQUIRED = "ACTION_REQUIRED",
  RESOLVED = "RESOLVED",
  COMMENT = "COMMENT",
}

export enum TEMPLATE {

  STEP1_JSON = "STEP1_TEMPLATE.json",
  STEP2_JSON = "STEP2_TEMPLATE.json",
  STEP3_JSON = "STEP3_TEMPLATE.json",
  REVIEW_JSON =  "REVIEW_TEMPLATE.json",

  V2_1_STEP1_JSON = "V2_1_STEP1_TEMPLATE.json",
  V2_2_STEP1_WF_JSON = "V2_2_STEP1_WF_TEMPLATE.json",
  V2_2_STEP1_FEEDBACK_TEMPLATE = "V2_2_STEP1_FEEDBACK_TEMPLATE.json",
  V2_3_REVIEW_JSON = "V2_3_REVIEW_TEMPLATE.json",
  V2_4_REVIEW_WF_JSON = "V2_4_REVIEW_WF_TEMPLATE.json",
  V2_4_REVIEW_FEEDBACK_TEMPLATE = "V2_4_REVIEW_FEEDBACK_TEMPLATE.json",
  V2_5_STEP2_JSON = "V2_5_STEP2_TEMPLATE.json",
  V2_6_STEP2_WF_JSON = "V2_6_STEP2_WF_TEMPLATE.json",
  V2_6_STEP2_FEEDBACK_TEMPLATE = "V2_6_STEP2_FEEDBACK_TEMPLATE.json",
  V2_7_COMPLETED_JSON = "V2_7_COMPLETED_TEMPLATE.json",

  EMAIL_LAYOUT = "EMAIL_LAYOUT.html",
  V2_EMAIL_LAYOUT = "V2_EMAIL_LAYOUT.html",

  PAGE_ABOUT = "PAGE_ABOUT.md",
  PAGE_RESOURCES = "PAGE_RESOURCES.md",
  PAGE_ANALYTICS = "PAGE_ANALYTICS.md",

  PROVIDER_ACCESS = "PROVIDER_ACCESS.md",
  PROVIDER_COURSE_CREATED = "PROVIDER_COURSE_CREATED.md",
  PROVIDER_COURSE_SUBMITTED = "PROVIDER_COURSE_SUBMITTED.md",
  PROVIDER_COURSE_APPROVED = "PROVIDER_COURSE_APPROVED.md",
  PROVIDER_COURSE_REJECTED = "PROVIDER_COURSE_REJECTED.md",
  PROVIDER_STEP_SUBMITTED = "PROVIDER_STEP_SUBMITTED.md",
  PROVIDER_STEP_APPROVED = "PROVIDER_STEP_APPROVED.md",
  PROVIDER_STEP_REJECTED = "PROVIDER_STEP_REJECTED.md",
  PROVIDER_COURSE_REMINDER = "PROVIDER_COURSE_REMINDER.md",
  REVIEWER_COURSE_ACCESS = "REVIEWER_COURSE_ACCESS.md",
  REVIEWER_SUBMITTED = "REVIEWER_SUBMITTED.md",
  REVIEWER_ACCESS = "REVIEWER_ACCESS.md",
  STAFF_STEP_SUBMITTED = "STAFF_STEP_SUBMITTED.md",
  PROVIDER_COMMENT_CLOSED = "PROVIDER_COMMENT_CLOSED.md",
  PROVIDER_COMMENT_CREATED = "PROVIDER_COMMENT_CREATED.md",
  PROVIDER_COMMENT_DELETED = "PROVIDER_COMMENT_DELETED.md",
  PROVIDER_COMMENT_REOPENED = "PROVIDER_COMMENT_REOPENED.md",
  PROVIDER_COMMENT_REPLY = "PROVIDER_COMMENT_REPLY.md",
  STAFF_COMMENT_CREATED = "STAFF_COMMENT_CREATED.md",
  STAFF_COURSE_REMINDER = "STAFF_COURSE_REMINDER.md",

  V2_PROVIDER_ACCESS = "V2_PROVIDER_ACCESS.md",
  V2_PROVIDER_COURSE_CREATED = "V2_PROVIDER_COURSE_CREATED.md",
  V2_PROVIDER_ASSIGNED = "V2_PROVIDER_ASSIGNED.md",
  V2_PROVIDER_COURSE_ASSIGNED = "V2_PROVIDER_COURSE_ASSIGNED.md",
  V2_PROVIDER_COURSE_APPROVED_GOOD = "V2_PROVIDER_COURSE_APPROVED_GOOD.md",
  V2_PROVIDER_COURSE_APPROVED_SATISFACTORY = "V2_PROVIDER_COURSE_APPROVED_SATISFACTORY.md",
  V2_PROVIDER_COURSE_REJECTED = "V2_PROVIDER_COURSE_REJECTED.md",
  V2_PROVIDER_STEP_SUBMITTED = "V2_PROVIDER_STEP_SUBMITTED.md",
  V2_PROVIDER_STEP_APPROVED = "V2_PROVIDER_STEP_APPROVED.md",
  V2_PROVIDER_STEP_REJECTED = "V2_PROVIDER_STEP_REJECTED.md",
  V2_PROVIDER_COURSE_REMINDER = "V2_PROVIDER_COURSE_REMINDER.md",
  V2_REVIEWER_COURSE_ACCESS = "V2_REVIEWER_COURSE_ACCESS.md",
  V2_REVIEWER_SUBMITTED = "V2_REVIEWER_SUBMITTED.md",
  V2_REVIEWER_ACCESS = "V2_REVIEWER_ACCESS.md",
  V2_STAFF_STEP_SUBMITTED = "V2_STAFF_STEP_SUBMITTED.md",

  V2_COMMENT_CLOSED = "V2_COMMENT_CLOSED.md",
  V2_COMMENT_CREATED = "V2_COMMENT_CREATED.md",
  V2_COMMENT_DELETED = "V2_COMMENT_DELETED.md",
  V2_COMMENT_REOPENED = "V2_COMMENT_REOPENED.md",
  V2_COMMENT_REPLY = "V2_COMMENT_REPLY.md",

  V2_PROVIDER_STEP_SUBMITTED_RETURNED = "V2_PROVIDER_STEP_SUBMITTED_RETURNED.md",
  V2_STAFF_STEP_SUBMITTED_RETURNED = "V2_STAFF_STEP_SUBMITTED_RETURNED.md",

  V2_PROVIDER_STEP_APPROVED_RETURNED = "V2_PROVIDER_STEP_APPROVED_RETURNED.md",
  V2_PROVIDER_STEP_REJECTED_RETURNED = "V2_PROVIDER_STEP_REJECTED_RETURNED.md",
  V2_STAFF_REVIEW_SUBMITTED = "V2_STAFF_REVIEW_SUBMITTED.md",

  V2_PROVIDER_REVIEW_GOOD = "V2_PROVIDER_REVIEW_GOOD.md",
  V2_PROVIDER_REVIEW_SATISFACTORY = "V2_PROVIDER_REVIEW_SATISFACTORY.md",
  V2_PROVIDER_REVIEW_REJECTED = "V2_PROVIDER_REVIEW_REJECTED.md",
  V2_PROVIDER_REVIEW_REJECTED_COMPLETED = "V2_PROVIDER_REVIEW_REJECTED_COMPLETED.md",
  V2_PROVIDER_REVIEW_REJECTED_OVERRULED = "V2_PROVIDER_REVIEW_REJECTED_OVERRULED.md",
  V2_PROVIDER_COURSE_APPROVED_SATISFACTORY_RETURNED = "V2_PROVIDER_COURSE_APPROVED_SATISFACTORY_RETURNED.md",
  
  V2_PROVIDER_AMENDMENT = "V2_PROVIDER_AMENDMENT.md",
  V2_STAFF_AMENDMENT = "V2_STAFF_AMENDMENT.md",
}
